import React from 'react';
import { motion } from 'framer-motion';
import type { Material } from '../../types';
import { CONSTANTS } from '../../data.js';

interface Props {
  item: Material;
  onPointerDown: (e: React.PointerEvent, itemId: string) => void;
}

export const InventoryItem = React.memo(function InventoryItem({ item, onPointerDown }: Props) {
  return (
    <motion.div
      layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onPointerDown={(e) => {
        if (item.category !== 'robot') onPointerDown(e, item.id);
      }}
      draggable={false}
      style={{ height: CONSTANTS.INVENTORY_ITEM_HEIGHT }}
      className={`w-full rounded-md border bg-slate-700/50 border-slate-600 flex items-center gap-2 px-2
        ${item.category !== 'robot' ? 'cursor-grab select-none' : 'cursor-default'}`}
      title={item.name}
    >
      <span className="text-xl">{item.icon}</span>
      <span className="text-sm truncate">{item.name}</span>
    </motion.div>
  );
});
